if(!customElements.get('custom-main-page')){
    class MainPage extends HTMLElement {
        constructor(){
            super();


            if(document.querySelectorAll('custom-image-banner').length == 0){
                var header = document.querySelector('custom-header');
                this.style.paddingTop = `${header.offsetHeight}px`;
            }
        }
    }

    customElements.define('custom-main-page', MainPage)
}